import Logger from '../utilities/logger';
import A11yConsentApi from '../a11y-consent-api';
import AbstractComponent from './abstract-component';
import Collapse from './collapse';

/**
 * Component for editing consent settings.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export default class Edit extends AbstractComponent {
  // Edit container is optionally wrapped in a collapsible element
  private readonly collapse: Collapse | null = null;

  constructor(api: A11yConsentApi, container: HTMLElement) {
    super(api, container);
    Logger.debug('edit', 'Starting to construct.');

    // If the edit component is wrapped in a collapse container, initialize the collapse component
    if (container.parentElement?.id === 'a11y-consent-edit-collapse') {
      const collapseContainer = container.parentElement;

      // The collapse component is only initialized, if it has a custom A11y Consent class. Users may use e.g. the
      // default Bootstrap collapsible instead.
      if (collapseContainer && collapseContainer.classList.contains('a11y-consent-collapse')) {
        const showCollapseButtons = document.querySelectorAll<HTMLButtonElement>(
          `[aria-controls="${container.parentElement.id}"]`
        );
        this.collapse = new Collapse(this.api, collapseContainer, showCollapseButtons);
      }
    }

    if (this.collapse) {
      this.api.emitter.on('acceptAll', () => {
        this.collapse?.hide();
      });
      this.api.emitter.on('rejectAll', () => {
        this.collapse?.hide();
      });
      this.api.emitter.on('save', () => {
        this.collapse?.hide();
      });
      this.collapse.emitter.on('show', () => {
        this.api.updateOptionControls();
      });
    }

    Logger.debug('edit', 'Finished constructing.');
  }
}
